import React, { useState, ChangeEvent, useEffect, useCallback } from 'react';

import { Row, Column } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import Text from 'components/Text';
import Form from 'components/Form';

import IconSearch from 'img/search-icon.svg';

import { CteInvoicingTableSearchProps } from './interface';
import {
  calcDataFrom,
  calcDataTo,
  getMaxDateInSearchFilter,
  getMinDateInSearchFilter
} from 'utils/Date';
import { addKeyPressListener, removeKeyPressListener } from 'utils/searchWithEnterPress';
import { DateOutputStr } from 'utils/DateOutput';
import PeriodDateToInput from 'components/PeriodDateToInput';

export const CteInvoicingTableSearch: React.FC<CteInvoicingTableSearchProps> = (props) => {
  const {
    setTableFilter,
    className,
    setCurrentPage
  } = props;

  const randomTableSearchId = `${Math.random() * 1000}`;

  const [newData, setNewData] = useState('');
  const [period, setPeriod] = useState({
    from: getMinDateInSearchFilter() ? DateOutputStr(getMinDateInSearchFilter().toISOString(), 'yyyy-MM-dd') : '',
    to: getMaxDateInSearchFilter() ? DateOutputStr(getMaxDateInSearchFilter().toISOString(), 'yyyy-MM-dd') : '',
  });

  useEffect(() => {
    addKeyPressListener(randomTableSearchId, makeFilter);

    return () => {
      removeKeyPressListener(randomTableSearchId, makeFilter);
    };
  }, []);

  const makeFilter = useCallback(() => {

    const newFilter = {
      startPeriod: period.from ? `${period.from}T00:00:00.000Z` : "",
      lastPeriod: period.to ? `${period.to}T23:59:59.999Z` : "",
    };

    setCurrentPage(0);
    setTableFilter(newFilter);
  }, [period]);

  const handleDateFirst = (e: ChangeEvent<HTMLInputElement>) => {
    setPeriod({ ...period, from: e.target.value });
    setNewData('end');
  };

  return (
    <Form id="table-search-cte" onValidate={makeFilter}>
      <Row
        id={randomTableSearchId}
        tabIndex={0}
        className={`mt-4 align-center flex-md-column align-md-none flex-wrap justify-md-none bg-white ${className || 'px-3 py-3'}`}
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >

        <Column className="flex-1 mr-2 mr-md-2 w-md-100 mt-md-3">
          <Text className="mr-2 mb-1 color-blue-gray" size={12} weight="bold">
            Período
          </Text>
          <Row className="flex-1 align-center">
            <input
              className="flex-1"
              value={period.from}
              onChange={handleDateFirst}
              type="date"
              max={period.to}
              placeholder="Início"
              onBlur={() => calcDataTo(period, newData, setPeriod)}
            />
            <Text className="mx-1 color-blue-gray" size={12} weight="bold">
              a
            </Text>
            <PeriodDateToInput
              setNewData={setNewData}
              onBlur={() => calcDataFrom(period, newData, setPeriod)}
              className="flex-1"
              period={period}
              setPeriod={setPeriod}
              placeHolder={"Fim"}
            />
          </Row>
        </Column>

        <Column className="mr-2 mt-md-3 w-md-100 pt-3 pt-md-0 ajustment-button">
          <Row>
            <Button
              tabIndex={0}
              className="focus-button"
              width="auto"
              onClick={makeFilter}
            >
              <img src={IconSearch} alt="" />
            </Button>
          </Row>
        </Column>

        <Row className="flex-1 w-md-100" />
      </Row>
    </Form>
  );
};